<sh-dialog *ngIf="config$ | async as config" [style]="style" [open]="open$ | async" (closed)="closeModal()">
    <med-fragment-preview-dialog [config]="config" (closeModal)="closeModal()"></med-fragment-preview-dialog>
</sh-dialog>
